import Cookies, { CookieAttributes } from 'js-cookie';

enum APP_ENVIROMENT {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  SANDBOX = 'sandbox',
  PRODUCTION = 'production',
  SUSTAINING = 'sustaining',
}

export const isEnvDevelopment =
  !process.env.REACT_APP_ENV ||
  process.env.REACT_APP_ENV === APP_ENVIROMENT.DEVELOPMENT;
const isEnvStaging = process.env.REACT_APP_ENV === APP_ENVIROMENT.STAGING;
const isEnvSandbox = process.env.REACT_APP_ENV === APP_ENVIROMENT.SANDBOX;
export const isEnvProduction =
  process.env.REACT_APP_ENV === APP_ENVIROMENT.PRODUCTION;
const isEnvSustaining = process.env.REACT_APP_ENV === APP_ENVIROMENT.SUSTAINING;

type AtEnvProps = {
  defaultValue: string;
  staging?: string | undefined;
  sandbox?: string | undefined;
  sustaining?: string | undefined;
  development?: string | undefined;
  production?: string | undefined;
};

const cookieOptions: CookieAttributes = {
  domain: isEnvDevelopment ? 'localhost' : '.covideo.com',
  path: '/',
  secure: true,
  sameSite: 'none',
  expires: 7,
};

let currentToken = null;

if (isEnvStaging || isEnvSandbox || isEnvSustaining || isEnvProduction) {
  currentToken = Cookies.get('jwt');
} else {
  currentToken = process.env.REACT_APP_JWT;
}

let refreshJwtToken = process.env.REACT_APP_REFRESH_JWT;
if (isEnvStaging || isEnvSandbox || isEnvSustaining || isEnvProduction) {
  refreshJwtToken = Cookies.get('refreshJwt');
}

export let token: any = currentToken;

export const updateToken = (
  tokenNew: string,
  refreshTokenNew?: string,
  domain?: string
) => {
  if (!tokenNew) return;
  if (domain) {
    cookieOptions.domain = `.${domain}`;
  }
  Cookies.set('jwt', tokenNew, cookieOptions);
  if (refreshTokenNew)
    Cookies.set('refreshJwt', refreshTokenNew, cookieOptions);
  token = tokenNew;
  currentToken = tokenNew;
};

export const getUpdatedHeader = () => {
  return {
    bearerToken: {
      Authorization: `Bearer ${token}`,
    },
    headers: {
      Authorization: token,
    },
  };
};

export const refreshToken = refreshJwtToken;

export const options = {
  bearerToken: {
    Authorization: `Bearer ${token}`,
  },
  headers: {
    Authorization: token,
  },
};

export const atEnv = ({
  defaultValue,
  development,
  sustaining,
  sandbox,
  staging,
  production,
}: AtEnvProps) => {
  if (isEnvDevelopment) {
    return !!development ? development : defaultValue;
  }
  if (isEnvStaging) {
    return !!staging ? staging : defaultValue;
  }
  if (isEnvSandbox) {
    return !!sandbox ? sandbox : defaultValue;
  }
  if (isEnvSustaining) {
    return !!sustaining ? sustaining : defaultValue;
  }
  if (isEnvProduction) {
    return !!production ? production : defaultValue;
  }
};

export const appUrl = atEnv({
  defaultValue: process.env.REACT_APP_APPURL || 'https://app.covideo.com',
  development: '',
  staging: process.env.REACT_APP_APPURL || 'https://app-staging.covideo.com',
  sandbox: process.env.REACT_APP_APPURL || 'https://app-sandbox.covideo.com',
  sustaining:
    process.env.REACT_APP_APPURL || 'https://app-sustaining.covideo.com',
  production: process.env.REACT_APP_APPURL || 'https://app.covideo.com',
});

enum API_EXPRESS_URL {
  DEVELOPMENT = 'https://localhost:3000/api/',
  STAGING = 'https://api-staging.covideo.com/',
  SANDBOX = 'https://api-sandbox.covideo.com/',
  PRODUCTION = 'https://api.covideo.com/',
  SUSTAINING = 'https://api-sustaining.covideo.com/',
}
export const apiExpress = atEnv({
  defaultValue: API_EXPRESS_URL.DEVELOPMENT,
  development: API_EXPRESS_URL.DEVELOPMENT,
  staging: API_EXPRESS_URL.STAGING,
  sandbox: API_EXPRESS_URL.SANDBOX,
  sustaining: API_EXPRESS_URL.SUSTAINING,
  production: API_EXPRESS_URL.PRODUCTION,
});

enum LANDING_PAGE_URL {
  DEVELOPMENT = 'http://localhost:3002/',
  STAGING = 'https://landing-staging.covideo.com/',
  SANDBOX = 'https://landing-sandbox.covideo.com/',
  PRODUCTION = 'https://landing.covideo.com/',
  SUSTAINING = 'https://landing-sustaining.covideo.com/',
}

export const landingPage = atEnv({
  defaultValue: LANDING_PAGE_URL.DEVELOPMENT,
  development: LANDING_PAGE_URL.DEVELOPMENT,
  staging: LANDING_PAGE_URL.STAGING,
  sandbox: LANDING_PAGE_URL.SANDBOX,
  sustaining: LANDING_PAGE_URL.SUSTAINING,
  production: LANDING_PAGE_URL.PRODUCTION,
});

enum LIVE_PAGE_URL {
  DEVELOPMENT = 'http://localhost:3004/',
  STAGING = 'https://live-staging.covideo.com/',
  SANDBOX = 'https://live-sandbox.covideo.com/',
  PRODUCTION = 'https://live.covideo.com/',
}

export const livePage = atEnv({
  defaultValue: LIVE_PAGE_URL.DEVELOPMENT,
  development: LIVE_PAGE_URL.DEVELOPMENT,
  staging: LIVE_PAGE_URL.STAGING,
  sandbox: LIVE_PAGE_URL.SANDBOX,
  production: LIVE_PAGE_URL.PRODUCTION,
});
